"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var material_1 = require("@mui/material");
var emoji_picker_react_1 = __importStar(require("emoji-picker-react"));
var emojiIcon_svg_1 = __importDefault(require("../../../assets/images/emojiIcon.svg"));
var attachIcon_svg_1 = __importDefault(require("../../../assets/images/attachIcon.svg"));
var common_1 = require("../../../common");
var App_1 = require("../../App");
var SubmitIcon_1 = require("./SubmitIcon");
var SizeExceededModal_1 = require("./SizeExceededModal");
var Replay_1 = require("./Replay");
var styles = __importStar(require("./ChatInput.module.css"));
var ChatInput = function (_a) {
    var replayMessage = _a.replayMessage, removeReplay = _a.removeReplay;
    var intl = (0, react_intl_1.useIntl)();
    var _b = (0, react_1.useContext)(App_1.WidgetContext), widgetSettings = _b.widgetSettings, socketService = _b.socketService, api = _b.api;
    var _c = (0, react_1.useState)(null), inputAnchor = _c[0], setInputAnchor = _c[1];
    var _d = (0, react_1.useState)(''), message = _d[0], setMessage = _d[1];
    var _e = (0, react_1.useState)(false), isSizeExceeded = _e[0], setIsSizeExceeded = _e[1];
    var _f = (0, react_1.useState)(null), cursorPosition = _f[0], setCursorPosition = _f[1];
    var textareaRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [replayMessage]);
    (0, react_1.useEffect)(function () {
        var textarea = textareaRef.current;
        if (cursorPosition !== null && textarea) {
            textarea.selectionStart = cursorPosition;
            textarea.selectionEnd = cursorPosition;
            setCursorPosition(null);
        }
    }, [cursorPosition, message]);
    var handleEmojiClick = function (event) {
        setInputAnchor(inputAnchor ? null : event.currentTarget);
    };
    var insertEmojiAtCursor = function (emoji) {
        var textarea = textareaRef.current;
        if (!textarea)
            return;
        var start = textarea.selectionStart;
        var end = textarea.selectionEnd;
        var updatedMessage = message.slice(0, start) + emoji + message.slice(end);
        setMessage(updatedMessage);
        setCursorPosition(start + emoji.length);
    };
    var onUploadFile = function (fileList) { return __awaiter(void 0, void 0, void 0, function () {
        var files, filesSize, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!fileList || !api || !socketService)
                        return [2 /*return*/];
                    files = Array.from(fileList);
                    filesSize = Array.from(fileList).reduce(function (totalSize, file) { return totalSize + file.size; }, 0);
                    if (filesSize > common_1.MAX_FILES_SIZE_BYTES)
                        return [2 /*return*/, setIsSizeExceeded(true)];
                    return [4 /*yield*/, api.sendFiles(files)];
                case 1:
                    response = _a.sent();
                    socketService.sendMessageEmit({ text: message, replyToId: replayMessage === null || replayMessage === void 0 ? void 0 : replayMessage.id, files: response });
                    removeReplay();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSendMessage = function () {
        if (!message.trim() || !socketService)
            return;
        socketService.sendMessageEmit({ text: message, replyToId: replayMessage === null || replayMessage === void 0 ? void 0 : replayMessage.id });
        setMessage('');
        removeReplay();
    };
    var onKeyDown = function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSendMessage();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.inputContainer }, { children: [(0, jsx_runtime_1.jsx)(Replay_1.Replay, { replayMessage: replayMessage, color: (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor) || common_1.DEFAULT_BACKGROUND_COLOR, removeReplay: removeReplay }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.inputWrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextareaAutosize, { autoFocus: true, maxRows: 6, value: message, onKeyDown: onKeyDown, onChange: function (e) { return setMessage(e.target.value); }, placeholder: intl.formatMessage({ id: 'chatInputPlaceholder' }), className: styles.textareaInput, ref: textareaRef }), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ "aria-label": 'emoji', color: 'inherit', onClick: handleEmojiClick }, { children: (0, jsx_runtime_1.jsx)("img", { src: emojiIcon_svg_1.default, alt: 'choose emoji', draggable: 'false' }) })), message.length === 0 ? ((0, jsx_runtime_1.jsxs)(material_1.IconButton, __assign({ "aria-label": 'file-upload', color: 'inherit', component: 'label' }, { children: [(0, jsx_runtime_1.jsx)("input", { hidden: true, type: 'file', id: 'file-upload', onChange: function (e) { return onUploadFile(e.target.files); }, multiple: true }), (0, jsx_runtime_1.jsx)("img", { src: attachIcon_svg_1.default, alt: 'attach file', draggable: 'false' })] }))) : ((0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ "aria-label": 'submit', color: 'inherit', sx: { ':hover': { backgroundColor: 'transparent' } }, onClick: onSendMessage }, { children: (0, jsx_runtime_1.jsx)(SubmitIcon_1.SubmitIcon, { color: (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor) || common_1.DEFAULT_BACKGROUND_COLOR }) })))] }))] })), (0, jsx_runtime_1.jsx)(material_1.Popover, __assign({ open: Boolean(inputAnchor), anchorEl: inputAnchor, onClose: handleEmojiClick, anchorOrigin: { vertical: 'top', horizontal: 'left' }, transformOrigin: { vertical: 'bottom', horizontal: 'left' } }, { children: (0, jsx_runtime_1.jsx)(emoji_picker_react_1.default, { emojiStyle: emoji_picker_react_1.EmojiStyle.NATIVE, previewConfig: { showPreview: false }, emojiVersion: '4.0', height: '65vh', width: '325px', onEmojiClick: function (emoji) { return insertEmojiAtCursor(emoji.emoji); } }) })), (0, jsx_runtime_1.jsx)(SizeExceededModal_1.SizeExceededModal, { isOpen: isSizeExceeded, buttonColor: (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor) || common_1.DEFAULT_BACKGROUND_COLOR, setIsOpen: setIsSizeExceeded })] }));
};
exports.ChatInput = ChatInput;
